import {Skeleton, Stack} from "@mui/material";
import React from "react";

export default function ChipsTabSkeleton() {
    return (
        <Stack direction="row" spacing={2} pl={3} pr={3} width="100%" alignItems="center">
            <Skeleton variant="rectangular" width="70px" height="25px" sx={{borderRadius: "1em"}}/>
            <Skeleton variant="rectangular" width="70px" height="25px" sx={{borderRadius: "1em"}}/>
            <Skeleton variant="rectangular" width="70px" height="25px" sx={{borderRadius: "1em"}}/>
            <Skeleton variant="rectangular" width="70px" height="25px" sx={{borderRadius: "1em"}}/>
        </Stack>
    );
}
